export default "__VITE_ASSET__BcXwQDT3__"